export default {

    data() {
        return {
            changeTypeColors: {
                minor: '#677EEA',
                major: '#ED742A',
                none: '#38B2AD'
            }
        }
    }

}